import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import {
  Nav,
  NavLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { scrollToElement } from '../../Code/Utilities';
import { AccountTypes } from '../../Code/Data';
import $ from 'jquery';

class MainMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { menuVisible: false };
  }

  toggleModal = () => {
    this.setState(prevState => ({
      menuVisible: !prevState.menuVisible,
    }));
  };

  openModal = () => {
    this.setState({ menuVisible: true });
  };
  showSitemap = () => {
    const navHeight = $('.navbar')[ 0 ].offsetHeight;
    scrollToElement('.sitemap', true, navHeight);
    this.toggleModal();
  };

  render() {
    const { currentUser, shoppingCart, userLogout } = this.props,
      accountType = currentUser && currentUser.AccountType,
      cartHasItems = shoppingCart && shoppingCart.Items && shoppingCart.Items.length > 0;
    return (
      <Fragment>
        <Button color="primary" onClick={this.openModal} block={this.props.block}>
          <span className="btn-inner--icon">
            <i className={'fa fa-bars'} />
          </span>
        </Button>
        <Modal
          className="side-menu-modal"
          isOpen={this.state.menuVisible}
          toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            {currentUser
              ? (<h3>Welcome {currentUser.FirstName}!</h3>)
              : (<h3>CharityChoice Main Menu</h3>)
            }
          </ModalHeader>
          <ModalBody role="navigation">
            <NavLink href="/Redeem">
              Redeem a Charity Gift Card
            </NavLink>
            <hr />
            <p>Purchase or Donate</p>
            <Nav vertical>
              <NavLink href="/Purchase/eCards">
                Digital Cards
                  <sub>100 graphics or upload your own</sub>
              </NavLink>
              <NavLink href="/Purchase/PrintCards">
                Printable Cards
                <sub>100 graphics or upload your own</sub>
              </NavLink>
              <NavLink href="/Purchase/PhysicalCards">
                Physical Gift Cards
                <sub>Our in-stock physical cards, designs for many occasions</sub>
              </NavLink>
              <NavLink href="/Purchase/CustomPhysicalCards">
                Custom Gift Cards
                <sub>Bulk orders with your logo or own design</sub>
              </NavLink>
              <NavLink href="/Purchase/RedemptionCodes">
                Get Active Redemption Codes
              </NavLink>
              <NavLink href="/Purchase/HonorCards">
                HonorCards
                <sub>Donate to a specific charity</sub>
              </NavLink>
              <NavLink href="/Purchase/DirectToCharityDonation">
                Make a Donation to Charity
              </NavLink>
              <NavLink href="/GCE">
                Donate a Merchant Gift Card
              </NavLink>
            </Nav>
            <hr />
            <p>Corporate and Events</p>
            <Nav vertical>
              <NavLink tag={Link} to="/CorporateSolutions" onClick={this.toggleModal}>Corporate Solutions</NavLink>
              <NavLink href="/custompageadmin/CreateCustomRedemptionPage/">Online Corporate Customization Wizard
              <sub>Custom redemption pages for your business gifts (needs corporate account)</sub>
              </NavLink>
              <NavLink href="/CorporateSolutions">Events &amp; Meetings</NavLink>
            </Nav>
            <hr />
            <p>Our Charities</p>
            <Nav vertical>
              <NavLink href="/Charities.aspx">List of our Charities
              <sub>View our list of Registered Charities</sub>
              </NavLink>
              <NavLink href="/AddNatLocalCharitiesRegistration/">Charity Application
              <sub>Register your charity on our list</sub>
              </NavLink>
              <NavLink href="/CharityLogin.aspx">Charity Login
              <sub>Login to modify your charity account, download reports, user optin info, etc.</sub>
              </NavLink>
            </Nav>
            {currentUser && accountType === AccountTypes.Personal &&
              <Fragment>
                <hr />
                <p>Personal Account</p>
                <Nav vertical>
                  <NavLink href="/status_account.aspx">Modify My Account
                  </NavLink>
                  <NavLink href="/myOrders.aspx">My Orders
                  </NavLink>
                </Nav>
              </Fragment>}
            {currentUser && accountType === AccountTypes.Charity &&
              <Fragment>
                <hr />
                <p>Charity Account</p>
                <Nav vertical>
                  <NavLink href="/status_account.aspx">Modify My Account
                  </NavLink>
                  <NavLink href="/Reports/CharityDistributionReport.aspx">Charity Distribution Reports
                  </NavLink>
                  <NavLink href="/status_account.aspx#CharityInformation">Upload or Change Logo
                  </NavLink>
                  <NavLink href="/GCE/CreateAd/">Accept Donations of Retail Gift Cards
                  </NavLink>
                </Nav>
              </Fragment>}
            {currentUser && accountType === AccountTypes.Corporate &&
              <Fragment>
                <hr />
                <p>Corporate Account</p>
                <Nav vertical>
                  <NavLink href="/status_account.aspx">Modify My Account
                  </NavLink>
                  <NavLink href="/myOrders.aspx">My Orders
                  </NavLink>
                  <NavLink href="/custompageadmin/CreateCustomRedemptionPage/">Create Custom Redemption Landing Page
                  <sub>Branded page</sub>
                  </NavLink>
                </Nav>
              </Fragment>}
            <hr />
            <NavLink onClick={() => {
              this.toggleModal();
              this.props.history.push('/#GiveGiftCards');
            }}>Purchase
            </NavLink>
            {cartHasItems &&
              <Fragment>
                <NavLink href="/Purchase/ShoppingCart">
                  My Cart
                </NavLink>
                <NavLink href="/Purchase/ShoppingCart">
                  Check Out
                </NavLink>
              </Fragment>
            }
            {currentUser
              ? <NavLink onClick={() => {
                userLogout();
                this.toggleModal();
              }}>
                Log Out of Account
                </NavLink>
              : <NavLink href="/Login.aspx">
                Account Login
                </NavLink>
            }
            <NavLink href="/FAQs.aspx">
              FAQs, Terms &amp; Conditions
            </NavLink>
            <NavLink href="https://charitychoicegc.wixsite.com/charitychoice" target="__blank">
              Blog
            </NavLink>
            <NavLink onClick={this.showSitemap}>
              Full Directory
          </NavLink>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(MainMenu);